import React from "react";
import styled from "styled-components";

const TestTable = styled.table`
  margin-top: 40px;

  & {
    width: 100%;
  }

  &,
  th,
  td {
    border-collapse: collapse;
    border-spacing: 0;
    border: 3px solid #ffffff;
  }

  th,
  td {
    vertical-align: top;
    text-align: left;
    padding: 20px;
  }

  tr {
    :not(:last-child) {
      th,
      td {
        :nth-child(1) {
          width: 115px;
        }
      }
    }

    :last-child {
      td {
        :first-child {
          text-align: right;
          color: #777777;
        }
      }
    }

    th {
      color: #777777;

      :nth-child(1),
      :nth-child(2) {
        font-size: 24px;
        line-height: 28px;
      }

      :nth-child(3),
      :nth-child(4) {
        font-size: 14px;
        line-height: 16px;
        width: 210px;
      }
    }

    td {
      font-size: 20px;
      line-height: 23px;

      :nth-last-child(2) {
        color: #777777;
      }

      :nth-last-child(1),
      :nth-last-child(2) {
        max-width: 210px;
      }

      :not(:nth-last-child(2)) {
        color: #000000;
      }
    }
  }
`;

const TableInputTd = styled.td`
  background: rgba(255, 255, 255, 0.5);
  padding: 0 !important;
  position: relative;
`;

const TdInput = styled.input`
  background-color: initial;
  border: none;
  font-size: 20px;
  width: 210px;
  padding: 20px;
  color: #000000;
  position: relative;
  font-family: RobotoBold, sans-serif;
`;

const TdError = styled.div`
  display: ${({ error }) => (error ? "block" : "none")};
  position: absolute;
  height: 107%;
  width: 103%;
  top: -3px;
  right: -3px;
  border-width: 3px;
  border-style: solid;
  border-color: ${({ error }) => (error ? "#DA5E50" : "#FFFFFF")};
`;

const TableFooter = styled.tr`
  color: #777777;

  td:last-child {
    font-family: RobotoBold, sans-serif;
  }
`;

export default ({ disabled, scores, handleChange }) => {
  const clearFocused = (e) => {
    const { name, id } = e.target;
    const error = scores[`error_${id}`];

    if (error) {
      const target = { name, id, value: "" };

      handleChange({ target });
    }
  };

  return (
    <TestTable>
      <tbody>
        <tr>
          <th>№ п/п</th>
          <th>Критерий оценки</th>
          <th>Максимальное количество баллов*</th>
          <th>Балл члена Конкурсной комиссии</th>
        </tr>
        <tr>
          <td>3.2.1.</td>
          <td>
            Обоснованность предлагаемого проекта: реалистичность,
            проработанность и полезность
          </td>
          <td>10</td>
          <TableInputTd>
            <TdError error={scores.error_1} />
            <TdInput
              id="1"
              type="text"
              maxLength="3"
              name="rating_1"
              value={scores.rating_1 || ""}
              disabled={disabled ? "disabled" : null}
              onChange={handleChange}
              onClick={clearFocused}
            />
          </TableInputTd>
        </tr>
        <tr>
          <td>3.2.2.</td>
          <td>Новизна и оригинальность предлагаемого проекта</td>
          <td>6</td>
          <TableInputTd>
            <TdError error={scores.error_2} />
            <TdInput
              id="2"
              type="text"
              maxLength="3"
              name="rating_2"
              value={scores.rating_2 || ""}
              disabled={disabled ? "disabled" : null}
              onChange={handleChange}
              onClick={clearFocused}
            />
          </TableInputTd>
        </tr>
        <tr>
          <td>3.2.3.</td>
          <td>
            Речевая цельность выступления, образность и грамотность речи,
            владение ораторскими приемами
          </td>
          <td>4</td>
          <TableInputTd>
            <TdError error={scores.error_3} />
            <TdInput
              id="3"
              type="text"
              maxLength="3"
              name="rating_3"
              value={scores.rating_3 || ""}
              disabled={disabled ? "disabled" : null}
              onChange={handleChange}
              onClick={clearFocused}
            />
          </TableInputTd>
        </tr>
        <TableFooter>
          <td colSpan="2">Максимальное количество баллов</td>
          <td>20</td>
          <td>{!!scores.is_skipped ? "пропуск" : scores.total}</td>
        </TableFooter>
      </tbody>
    </TestTable>
  );
};
